
// import React, { useState } from "react";
// import { Box, Button, Typography } from "@mui/material";
// import { Formik, Form } from "formik";
// import * as Yup from "yup";
// import CustomInput from "../../Components/CustomInput/CustomInput";
// import { toast, ToastContainer } from "react-toastify";
// // import { useDispatch, useSelector } from "react-redux";
// import OtpsSendModal from "../../Components/OtpSendModal/OtpsSendModal";
// // import actions from "../../ReduxStore/actions";
// import { useNavigate } from "react-router-dom";
// import CustomInputLogin from "../../Components/CustomInputLogin/CustomInputLogin";
// import actions from "../../ReduxStore/actions";
// import { useDispatch } from "react-redux";
// // import { setInitialStateOfresetPasswordForCustomer } from "../../ReduxStore/Slices/VerificationOtp/resetPasswordForCustomer";
// // import { setInitialStateOfEmailVerifyOtp } from "../../ReduxStore/Slices/VerificationOtp/EmailVerifyOtp";

// const ForgotPasswordForm = ({ toggleSignIn }) => {
//   const dispatch = useDispatch();

//   const [showSetNewPassword, setShowSetNewPassword] = useState(false);


//   const [resetPassword, setResetPassword] = useState();
//   const navigate = useNavigate();
//   // Component state
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [submittedValues, setSubmittedValues] = useState("");

//   // Modal handlers
//   const handleOpenModal = () => setModalOpen(true);
//   const handleCloseModal = () => setModalOpen(false);

//   // Formik initial values
//   const initialValues = {
//     employeeCode: "",
//     // password: "",
//   };

//   // Separate validation schemas
//   const validationSchemaBeforeOTP = Yup.object({
//     email: Yup.string()
//       .email("Invalid email address")
//       .required("Email is required"),
//   });

//   const validationSchemaAfterOTP = Yup.object({
//     password: Yup.string().required("Password is required"),
//   });

//   const handleSubmit = async (values) => {
//     console.log(values, "Values")
//     handleOpenModal()
//     try {
//       if ("OTP verified successfully") {
//         setShowSetNewPassword(true);
//         const requestData = {
//           data: {
//             email: values.email,
//             newPassword: values.password,
//           },
//           method: "post",
//           apiName: "resetPasswordForCustomer",
//         };

//         const newPasswordData = await dispatch(
//           actions.RESETPASSWORDFORCUSTOMER(requestData)
//         );

//         console.log(
//           newPasswordData,
//           "newPasswordDatanewPasswordDatanewPasswordData"
//         );
//         if (
//           newPasswordData?.payload?.message ===
//           "Password has been reset successfully."
//         ) {
//           setShowSetNewPassword(false);

//           setResetPassword(newPasswordData);
//           toast.success("Password has been reset successfully.");

//           console.log("hejnjnknbkjbkjbky");

//           // Await the state reset to ensure it completes before moving forward

//           // Delay navigation to ensure user sees the success message
//           // setTimeout(() => {
//           toggleSignIn();
//           // dispatch(setInitialStateOfEmailVerifyOtp());
//           // dispatch(setInitialStateOfresetPasswordForCustomer());
//           // }, 1500);

//           setTimeout(() => {
//             toggleSignIn();
//             // dispatch(setInitialStateOfEmailVerifyOtp());
//             // dispatch(setInitialStateOfresetPasswordForCustomer());
//           }, 3000);
//         } else {
//           toast.error(
//             newPasswordData?.payload?.message || "Failed to reset the password."
//           );
//         }
//       } else {
//         const requestData1 = {
//           data: {},
//           method: "post",
//           apiName: `getEmployeeEmailByCode/${values?.employeeCode}`,
//         };
//         // handleOpenModal();
//         // toast.success("OTP sent successfully.");

//         const getEmployeeEmailByCodeData = await dispatch(actions.GETEMPLOYEEEMAILBYCODE(requestData1));
//         if (getEmployeeEmailByCodeData?.payload?.message === "Employee email fetched successfully.") {
//           const requestData = {
//             data: { email: getEmployeeEmailByCodeData?.payload?.data?.email },
//             method: "post",
//             apiName: "sendOTP",
//           };
//           handleOpenModal();
//           toast.success("OTP sent successfully.");

//           const OtpSendData = await dispatch(actions.EMAILSENDOTP(requestData));
//           if (OtpSendData?.payload?.message === "OTP sent successfully!") {
//             // toast.success("OTP sent successfully.");
//             setSubmittedValues(values.email); // Store email in the state
//             // handleOpenModal();
//           } else {
//             toast.error("Please enter a valid email.");
//           }


//         }



//       }
//     } catch (error) {
//       console.error("Error during handleSubmit:", error);
//       toast.error("An unexpected error occurred. Please try again.");
//     }
//   };

//   return (
//     <>
//       <Formik
//         initialValues={initialValues}
//         // validationSchema={
//         //   EmailVerifyOtp?.message === "OTP verified successfully"
//         //     ? validationSchemaAfterOTP
//         //     : validationSchemaBeforeOTP
//         // }
//         onSubmit={handleSubmit}
//       >
//         {({ values, errors, touched, setFieldValue }) => (
//           <Form style={{ width: "100%" }}>
//             <Box mb={2}>
//               {/* Email Input */}
//               {EmailVerifyOtp?.message !== "Employee email fetched successfully." && (
//                 <CustomInputLogin
//                   name="employeeCode"
//                   label="Emplyee Code"
//                   custPlaceholder="Enter Employee Code"
//                   inputType="number"
//                 />
//               )}


//               {/* {EmailVerifyOtp?.message === "OTP verified successfully" &&
//                 resetPasswordForCustomer.message !==
//                 "Password has been reset successfully." && ( */}
//               <>
//                 <CustomInput
//                   name="email"
//                   label="Email"
//                   custPlaceholder="Enter Email"
//                   inputType="text"
//                   value={values.email}
//                   readOnly
//                 />
//                 <CustomInput
//                   name="password"
//                   label="New password"
//                   custPlaceholder="Enter New Password"
//                   inputType="password"
//                 />
//               </>
//               {/* )} */}
//             </Box>

//             {/* Submit Button */}
//             <Button
//               fullWidth
//               type="submit"
//               variant="contained"
//               sx={{
//                 textTransform: "none",
//                 // borderRadius: 23,
//                 py: "7px",
//                 color: "white",
//                 backgroundColor: "var(--main-color)",
//                 "&:hover": {
//                   backgroundColor: "var(--main-color)",
//                 },
//               }}
//               aria-label="Submit"
//             >
//               {/* {EmailVerifyOtp?.message === "OTP verified successfully"
//                 ? "Reset password"
//                 : "Send OTP"} */}
//               Send OTP
//             </Button>

//             {/* OTP Modal */}
//             <OtpsSendModal
//               open={isModalOpen}
//               onClose={handleCloseModal}
//               submittedValues={submittedValues}
//             />

//             {/* Back Button */}
//             {toggleSignIn && (
//               <Typography
//                 variant="body1"
//                 onClick={toggleSignIn}
//                 sx={{
//                   mt: 2,
//                   textAlign: "center",
//                   cursor: "pointer",
//                   color: "var(--main-color)",
//                 }}
//               >
//                 Go Back
//               </Typography>
//             )}
//           </Form>
//         )}
//       </Formik>
//     </>
//   );
// };

// export default ForgotPasswordForm;

import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import CustomInput from "../../Components/CustomInput/CustomInput";
import CustomInputLogin from "../../Components/CustomInputLogin/CustomInputLogin";
import OtpsSendModal from "../../Components/OtpSendModal/OtpsSendModal";
import actions from "../../ReduxStore/actions";
import FullPageLoader from "../../Components/FullPageLoader/FullPageLoader";

const ForgotPasswordForm = ({ toggleSignIn }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showSetNewPassword, setShowSetNewPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [employeeCode, setEmployeeCode] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const initialValues = {
    employeeCode: "",
    email: "",
    password: "",
  };
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    password: showSetNewPassword
      ? Yup.string().required("Password is required")
      : Yup.string(),
    employeeCode: Yup.string().required("Employee Code is required"),
  });

  const handleSubmit = async (values, { setFieldValue }) => {
    try {
      if (showSetNewPassword) {
        setLoading(true)
        const requestData = {
          data: {
            employee_code: employeeCode,
            newPassword: values.password,
          },
          method: "post",
          apiName: "resetPasswordForEmployee",
        };

        const newPasswordData = await dispatch(actions.RESETPASSWORDFOREMPLOYEE(requestData));

        if (newPasswordData?.payload?.message === "Password reset successfully.") {
          setLoading(false)
          toast.success("Password has been reset successfully.");
          setShowSetNewPassword(false);

          setTimeout(() => {
            toggleSignIn();
          }, 3000);
        } else {
          setLoading(false)
          toast.error(
            newPasswordData?.payload?.message || "Failed to reset the password."
          );

        }
      } else {
        setLoading(true)
        const employeeCodeData = {
          data: {},
          method: "get",
          apiName: `getEmployeeEmailByCode/${values?.employeeCode}`,
        };

        const getEmailRes = await dispatch(actions.GETEMPLOYEEEMAILBYCODE(employeeCodeData));

        if (getEmailRes?.payload?.message === "Employee email fetched successfully.") {
          const userEmail = getEmailRes?.payload?.data?.email;
          console.log(userEmail, "userEmail")
          const otpRequestData = {
            data: { email: userEmail },
            method: "post",
            apiName: "sendOTP",
          };

          const otpRes = await dispatch(actions.SENDOTP(otpRequestData));

          if (otpRes?.payload?.message === "OTP sent successfully!") {
            setLoading(false)
            toast.success("OTP sent successfully.");
            setEmail(userEmail);
            setEmployeeCode(values?.employeeCode);
            setModalOpen(true);
          } else {
            setLoading(false)

            toast.error("Failed to send OTP.");
          }
        } else {
          setLoading(false)
          toast.error("Invalid Employee Code.");
        }
      }
    } catch (error) {
      setLoading(false)

      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong. Try again.");
    }
  };

  const handleOtpVerified = () => {
    // setShowSetNewPassword(true);
    setModalOpen(false);
  };

  return (
    <>
      {loading && <FullPageLoader />}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form style={{ width: "100%" }}>
            <Box mb={2}>
              {/* Employee Code */}
              <CustomInputLogin
                name="employeeCode"
                label="Employee Code"
                custPlaceholder="Enter Employee Code"
                inputType="number"
                // value={employeeCode}
                readOnly={showSetNewPassword}
              />

              {/* Email - Show only if OTP is verified */}
              {showSetNewPassword && (
                <CustomInput
                  name="email"
                  label="Email"
                  custPlaceholder="Enter Email"
                  inputType="text"
                  value={email}
                  readOnly
                />
              )}

              {/* Password Input - only after OTP verified */}
              {showSetNewPassword && (
                <CustomInput
                  name="password"
                  label="New Password"
                  custPlaceholder="Enter New Password"
                  inputType="password"
                />
              )}
            </Box>

            {/* Submit Button */}
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                textTransform: "none",
                py: "7px",
                color: "white",
                backgroundColor: "var(--main-color)",
                "&:hover": {
                  backgroundColor: "var(--main-color)",
                },
              }}
            >
              {showSetNewPassword ? "Reset Password" : "Send OTP"}
            </Button>

            {/* OTP Modal */}
            <OtpsSendModal
              open={isModalOpen}
              onClose={handleCloseModal}
              submittedValues={email}
              onOtpVerified={handleOtpVerified}
              setShowSetNewPassword={setShowSetNewPassword}
            />

            {/* Back Link */}
            {toggleSignIn && (
              <Typography
                variant="body1"
                onClick={toggleSignIn}
                sx={{
                  mt: 2,
                  textAlign: "center",
                  cursor: "pointer",
                  color: "var(--main-color)",
                }}
              >
                Go Back
              </Typography>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ForgotPasswordForm;
